// extracted by mini-css-extract-plugin
export default {"yourContentBanner":"fm7GZaCAwsJHS3pGHNZI","yourChoice":"xFiOXPFEQRyCCIZoh9WE","highlight":"_0aSRpT831MmeV0OFNTaQ","embrace":"CRHePijy39yirZ5k1X3j"};